<div class="min-success centerWidth">
    <div class="main-success-header col-12 flex flex-wrap ">
        <div class="col-8  md:col-12 success-title" (click)="goToStoryListPage()"><h2>{{title}}</h2></div>
        <div class="col-8 hidden md:block  success-summery">
            <span *ngIf="showDet" i18n="@@success stories Det">det</span>
        </div>

        <div *ngIf="items.scrollWidth>items.offsetWidth && getDirection()=='rtl'" style="height: 55px" class="col-4 md:col-6  next-prev-div" >
            <div class="next-btn {{items.scrollLeft>-1?'btnDisable':''}}" (click)="right(items)">
                <span></span><i class="pi pi-angle-right"></i>
            </div>
            <div class="previous-btn {{items.scrollWidth-18 < (items.offsetWidth+(-1*items.scrollLeft))?'btnDisable':''}} " (click)="left(items)">
                <span></span><i class="pi pi-angle-left"></i>
            </div>
        </div>
        <div *ngIf="items.scrollWidth>items.offsetWidth && getDirection()=='ltr'" style="height: 55px" class="col-4 md:col-6  next-prev-div" >
            <div class="previous-btn {{items.scrollWidth-1 < (items.offsetWidth+(-1*items.scrollLeft))?'btnDisable':''}} " (click)="left(items)">
                <span></span><i class="pi pi-angle-left"></i>
            </div>
            <div class="next-btn {{items.scrollLeft>items.offsetWidth?'btnDisable':''}}" (click)="right(items)">
                <span></span><i class="pi pi-angle-right"></i>
            </div>

        </div>
    </div>
    <div #items dragScroll class="col-12 flex  items  " style="min-height:550px;">
        <ng-container *ngFor="let page of pages">
            <app-success-story-item class="col-12 xlg:col-3 lg:col-3 md:col-4 " style="    padding: 0px 19px;margin: 0px -8px;"
                                    backColor="{{page.style.bgColor}}"
                                    logoPath="{{config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.w_logo_image }}"
                                    backImage="{{config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.bgImage }}"
                                    title="{{page.title}}"
                                    text="{{page.summary}}"
                                    pageUid="{{page.uid}}"
            ></app-success-story-item>
        </ng-container>
        <div class="col-12 xlg:col-3 lg:col-3 md:col-4  " style="height: 555px;">
            <div class="see-more">
                <p class="text" i18n="@@View all success stories">
                    View all success stories
                </p>
                <div class="  more-div">
                    <button class="button more-btn" (click)="goToStoryListPage()"><span
                            i18n="@@See more">See more</span>
                        <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
                        <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
                    </button>
                </div>
            </div>

        </div>
    </div>

</div>
